import { render, staticRenderFns } from "./PublicNavMenuHeaderGroup.vue?vue&type=template&id=c0ed06e6&"
import script from "./PublicNavMenuHeaderGroup.vue?vue&type=script&lang=js&"
export * from "./PublicNavMenuHeaderGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports